import { Button, Tooltip, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

import { Word } from "../../../../types/words";

import styles from "../../../../components/TasksTable/TableColumns/columns.module.css";
import popconfirmStyles from "./WordsActionRow.module.css";

interface WordsActionRowProps {
  word: Word;
  isEditing?: boolean;
  isWordValid?: boolean;
  onEdit?: () => void;
  onSave?: () => void;
  onCancel?: () => void;
  onDelete?: (wordKey: string) => void;
}

const WordsActionRow = ({ word, isEditing = false, isWordValid = true, onEdit, onSave, onCancel, onDelete }: WordsActionRowProps) => {
  const handleDeleteConfirm = () => {
    onDelete?.(word.id);
  };

  if (isEditing) {
    return (
      <div className={styles.tableRowActions}>
        <Tooltip title={isWordValid ? "Guardar canvis" : "Completa tots els camps obligatoris"}>
          <Button 
            type="primary"
            icon={<CheckOutlined />} 
            onClick={onSave}
            disabled={!isWordValid}
          />
        </Tooltip>
        <Tooltip title="Cancel·lar">
          <Button 
            icon={<CloseOutlined />} 
            onClick={onCancel}
          />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={styles.tableRowActions}>
      <Tooltip title="Editar paraula">
        <Button 
          icon={<EditOutlined />} 
          onClick={onEdit}
        />
      </Tooltip>
      <Popconfirm
        title="Esborrar paraula"
        description="Estàs segur que vols esborrar aquesta paraula? Aquesta acció és irreversible."
        onConfirm={handleDeleteConfirm}
        okText="Sí"
        cancelText="No"
        okButtonProps={{ danger: true }}
        placement="bottomRight"
        overlayClassName={popconfirmStyles.deletePopconfirm}
      >
        <Tooltip title="Esborrar paraula">
          <Button 
            icon={<DeleteOutlined />} 
          />
        </Tooltip>
      </Popconfirm>
    </div>
  );
};

export default WordsActionRow;